import { floatMul,floatDiv } from "@/util/util";

export function overdueListConfig(getMoney, selectPersonClick, selectDeptClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    searchShow:false,
    // index: true,
    // indexLabel: "序号",
    refreshBtn: true,
    column: [{
        label: "项目名称",
        placeholder: "请输入项目名称",
        search: true,
        searchslot:true,
        slot: true,
        prop: "projectName",
        width: "180",
        overHidden: true
      },
      {
        label: "客户名称",
        placeholder: "请输入客户名称",
        search: true,
        prop: "sellerCustName",
        width: "180",
        overHidden: true
      },
      // {
      //   label: '保理商',
      //   prop: "accountingEntityStr",
      //   // type: "select",
      //   // dicUrl: '/api/blade-system/dict-biz/dictionary?code=rzzl_accounting_entity',
      //   // dataType: 'number',
      //   // props: {
      //   //   label: "dictValue",
      //   //   value: "dictKey"
      //   // },
      //   width: '280',

      // },
      {
        label: "保理合同",
        prop: "contractName",
        width: "180",
        overHidden: true
      },
      {
        label: "期数",
        prop: "phase",
        slot: true,
        width: "100",
        overHidden: true,

      },
      {
        label: "批次",
        prop: "batch",
        width: "100",
        overHidden: true,
        formatter: (row, value, label, column) => {
          return `第${value}批`;
        }
      },
      {
        label: "还款日",
        prop: "rentDate",
        width: "110",
        overHidden: true
      },

      {
        label: '超期类型',
        prop: "overdueTypeStr",
        width: "100",
        overHidden: true,
        slot:true

      },

      {
        label: "应收账款(元）",
        prop: "receivableRent",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      },
      {
        label: "天数(天）",
        prop: "overdueDays",
        width: "100",
        overHidden: true,
        formatter: (row, value, label, column) => {
          return row.overdueDays + '+' + (row.expireDays ? (+row.expireDays) : '0');
        }
      },
      {
        label: "超期金额(元）",
        prop: "overdueAmount",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: "减免金额(元）",
        prop: "creditAmount",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: "超期确认金额(元）",
        prop: "overdueConfirmAmount",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      },
      {
        label: '归还状态',
        prop: "paymentStr",
      },
      {
        label: '超期类型',
        prop: "isOverdue",
        type: "select",
        // dicUrl: '/api/blade-system/dict-biz/dictionary?code=rzzl_accounting_entity',
        // dataType: 'number',
        // props: {
        //   label: "dictValue",
        //   value: "dictKey"
        // },
        width: '150',
        search: true,
        hide: true,
        dicData: [{
            label: "宽限期",
            value: 0,
          },
          {
            label: "逾期",
            value: 1,
          },
        ],
      },
      {
        label: '归还状态',
        prop: "isPayment",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=is_payment',
        dataType: 'number',
        search: true,
        hide: true,
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        width: '150',
      }

    ]
  }
}

export function projectConfig() {
  return [{
      label: '项目名称',
      prop: 'custName',
      span: '12'
    },
    {
      label: '合同编号',
      prop: 'custCategory',
      span: '12',
      formatter: (label, value) => {
        let returnData = value == 1 ? '个人客户' : value == 2 ? '机构客户' : '无'
        return returnData
      }
    },
    {
      label: '客户名称',
      prop: 'custSourceStr',
      span: '12'
    },
    {
      label: '业务类型',
      prop: 'custAttributeStr',
      span: '12'
    },
    {
      label: '批次',
      prop: 'industryStr',
      span: '12'
    },
    {
      label: '保理商',
      prop: 'enterpriseTypeStr',
      span: '12'
    },
  ]
}


export function overdueDetailConfig(getMoney) {
  return [
    // {
    //   label: '客户名称',
    //   prop: 'sellerCustName',
    //   span: '8',

    // },
    // {
    //   label: '保理商',
    //   prop: 'accountingEntityStr',
    //   span: '10',

    // },

    {
      label: '保理合同',
      prop: 'contractName',
      span: '8',

    },
    {
      label: '期数',
      prop: 'phase',
      span: '8',
      formatter: (row, value, label, column) => {
        return `第${value}期`;
      }
    },
    {
      label: '超期类型',
      prop: 'overdueTypeStr',
      span: '8',

    },
    {
      label: '应收金额',
      prop: 'receivableRent',
      span: '8',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '天数',
      prop: 'days',
      span: '8',

    },
    {
      label: '超期金额',
      prop: 'overdueAmount',
      span: '8',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '减免金额',
      prop: 'creditAmount',
      span: '8',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '超期确认金额',
      prop: 'overdueConfirmAmount',
      span: '8',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '还款日',
      prop: 'rentDate',
      span: '8',

    },{
      label: '业务主办',
      prop: 'managerUserName',
      span: '8',

    },{
      label: '业务协办',
      prop: 'assistUserName',
      span: '8',
    }
  ]

}


export function overdueDetailListConfig(getMoney) {
  return {
    menuType: "button",
    menuWidth: 380,
    menuAlign: "center",
    align: "center",
    card: false,
    tip: false,
    lazy: false,
    tree: false,
    filterable: false,
    editBtn: false,
    cellBtn: false,
    delBtn: false,
    addBtn: false,
    selection: false,
    searchBtn: false,
    columnBtn: false,
    refreshBtn: false,
    labelWidth: 200,
    index: true,
    indexLabel: "序号",
    dialogClickModal: false,
    menu: false,
    column: [{
        label: "日期",
        prop: "interestDate",

        display: true,
      },
      {
        label: "金额（元）",
        prop: "receivableRent",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        },
        display: true,
      },
      {
        label: "当日费率",
        prop: "overdueInterestRate",
        formatter: (row, value, label, column) => {
          return row.isOverdue === 1 ? floatMul(Number(row.overdueInterestRate) , 100) + '%' : row.isOverdue === 0 ? floatMul(Number(row.gracePeriodRate) , 100) + '%' : '';
        },
      },

      {
        label: "当日费用（元）",
        prop: "interestAmount",
      },
      {
        label: "属性",
        prop: "isOverdue",
        formatter: (row, value, label, column) => {
          return value === 1 ? '逾期使用费' : value === 0 ? '宽限期使用费' : '';
        },
      },
    ],
  }
}
